module.exports = __webpack_public_path__ + "static/map_fra-f074d8db040d49e1230914d60e99e8f9.png";